<template>
    <modal :show-title="true" size="small" @close="$emit('close')">
        <div slot="header">
            <h5 class="modal-title">{{$t('prenotazione.annulla')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <p class="text-center">{{$t('prenotazione.info_annulla')}}</p>
            <br/>
            <i class="fa fa-phone fa-4x"></i>
            <br/>
            <h2>{{this.phone}}</h2>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../partials/Modal";

    export default {
        name: "ModalCancelReservation",
        components: {Modal},
        props: ['phone']
    }
</script>
